<template>
	<div class="single-page-wrap">
		<div class="wrapper single-page-wrap" v-if="isMerchant == 1">
			<article class="weui-article">
				<section>
					<div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
						<div class="weui-cell__hd"><label class="weui-label">已选停车场</label></div>
						<div class="weui-cell__bd" @click="handleParkOption">{{ checkedPark }}</div>
					</div>
					<p>购买停车券后，停车券可能不会立即生成，请等待10秒后刷新该页面即可看到。</p>
				</section>
			</article>
			<div class="weui-btn-area">
				<button class="weui-btn"
					:class="checkedParkOptions.length <= 0 ? 'weui-btn_disabled' : 'weui-btn_primary'"
					@click="handleBuy" :disabled="checkedParkOptions.length <= 0">购买停车券</button>
			</div>
			<!-- <article class="weui-article">
				<p>您当前有{{ couponList.length }}份停车券可用</p>
			</article> -->

			<cube-scroll ref="scroll" class="cube-scroll" :options="scrollOptions">
				<div class="fee-list-wrapper" v-if="couponList.length > 0">
					<div class="weui-cells-wrapper" v-for="item of couponList" :key="item.id">
						<div class="weui-cells">
							<div class="weui-cell">
								<div class="weui-cell__bd">
									<p>停车场</p>
								</div>
								<div class="weui-cell__ft">{{ item.parkinglotName }}</div>
							</div>
							<div class="weui-cell">
								<div class="weui-cell__bd">
									<p>券类型</p>
								</div>
								<div class="weui-cell__ft">{{ item.coupontypeName }}</div>
							</div>
							<div class="weui-cell">
								<div class="weui-cell__bd">
									<p>券名称</p>
								</div>
								<div class="weui-cell__ft">{{ item.couponName }}</div>
							</div>
							<div class="weui-cell" v-if="item.couponType != 10">
								<div class="weui-cell__bd">
									<p>剩余张数</p>
								</div>
								<div class="weui-cell__ft">{{ item.remainQuantity }}张</div>
							</div>
							<div class="weui-cell" v-if="item.couponType == 10">
								<div class="weui-cell__bd">
									<p>余额</p>
								</div>
								<div class="weui-cell__ft">{{ item.amountBalance }}元</div>
							</div>
							<div class="weui-cell">
								<div class="weui-cell__bd">
									<p>备注</p>
								</div>
								<div class="weui-cell__ft">{{ item.remark }}</div>
							</div>
							<i v-show="item.isExpiration === 1" class="iconfont icon-guoqi"></i>
						</div>
						<div class="weui-btn-wrapper">
							<!-- <button v-if="item.couponType != 9 && item.couponType != 10"
								class="weui-btn weui-btn_mini weui-btn_default"
								v-show="item.remainQuantity > 0 && item.isExpiration === 0"
								@click="handleRation(item.id)">立即发放</button> -->

							<button v-if="item.couponType == 10" class="weui-btn weui-btn_mini weui-btn_default"
								@click="handlePayment(item)">代付抵扣</button>

							<button v-if="item.couponType != 9" class="weui-btn weui-btn_mini weui-btn_default"
								v-show="item.remainQuantity > 0 && item.isExpiration === 0"
								@click="chooseRationType(item.id)">发放方式</button>

							<button class="weui-btn weui-btn_mini weui-btn_default"
								v-show="item.remainQuantity > 0 && item.isExpiration === 0"
								@click="handleBind(item.id, item.parkinglotId, item.couponType)">直接绑定</button>


							<button class="weui-btn weui-btn_mini weui-btn_default"
								v-if="item.couponType == 10 && item.status != 0"
								@click="handleBind(item.id, item.parkinglotId, item.couponType)">直接绑定</button>

							<button class="weui-btn weui-btn_mini weui-btn_default"
								v-if="item.couponType == 10 && item.status != 0"
								@click="PaymentType(item.id, item.parkinglotId, item.couponType)">车牌代付</button>


							<!--<button class="weui-btn weui-btn_mini weui-btn_default" v-show="item.remainQuantity > 0 && item.isExpiration === 0"-->
							<!--@click="handleRationByDay(item.id)">按天发放</button>-->
							<button class="weui-btn weui-btn_mini weui-btn_default"
								@click="handleRecord(item)">发放记录</button>
						</div>
					</div>
				</div>
				<no-data v-else msg="暂无"></no-data>
			</cube-scroll>
			<div class="js_dialog" v-show="isShowQrcode">
				<div class="weui-mask"></div>
				<div class="weui-dialog">
					<div class="weui-dialog__bd">
						<vue-qr :text="url" :margin="0" :size="250"></vue-qr>
					</div>
					<div class="weui-dialog__ft" @click="close">
						<a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary">关闭</a>
					</div>
				</div>
			</div>
		</div>
		<div v-else-if="isMerchant == 2" class="no-enter">
			<p>只有商户才能进入该页面</p>
		</div>
	</div>
</template>

<script>
import { getWxUserInfo } from "@/api/coupon/personalCenter";
import CryptoJS from 'crypto-js'
import { selectBussinessParkinglot, selectBussinessCoupon, sendCoupon } from '@/api/coupon/merChantParkingFee'
import { mapGetters, mapMutations } from 'vuex'
import vueQr from 'vue-qr';
import scan from '@/api/coupon/scan'
import encrypt from '../../../utils/encrypt'

export default {
	name: 'merChantParkingFee',
	data() {
		return {
			timer: undefined,
			isMerchant: 0,
			checkedPark: undefined,
			checkedParkId: undefined,
			checkedParkOptions: [],
			couponList: [],
			couponUrlList: [],
			scrollOptions: {
				click: true,
				bounce: false
			},
			parkinglotId: undefined,
			url: "",
			isShowQrcode: false,
			rationType: undefined,
			checkedRationOptions: [
				{ id: 1, label: '按天发放' },
				// { id: 2, label: '轮询发放' },
				{ id: 4, label: '轮询发放(手输)' },
				{ id: 3, label: '自输车牌' },
				{ id: 5, label: '当天有效' }
			]
		}
	},
	components: {
		vueQr,
	},
	computed: {
		...mapGetters(['userPhone', "userOpenid", "businessIds"])
	},
	mounted() {
		console.log("22222222");
		this.getWxUserInfo();
	},
	activated() {
		// this.getBussinessCoupon();
	},
	methods: {
		...mapMutations({
			setCheckedParkingLotId: "SET_CHECKED_PARKINGLOT_ID",
			setTaskId: "SET_TASK_ID",
			setCouponId: "SET_COUPON_ID",
		}),
		getWxUserInfo() {
			getWxUserInfo(localStorage.getItem('userOpenId') || this.userOpenid).then(req => {
				if (req.code == 200 && req.data) {
					if (req.data.businessIds) {
						this.isMerchant = 1;
						if (req.data.businessIds.length <= 0) {
							this.isMerchant = 2
						} else {
							this.isMerchant = 1;
							this.getBussinessParkinglot();
						}
					} else {
						this.isMerchant = 2;
					}
				}
			});
		},
		/** 获取商户所属停车场*/
		getBussinessParkinglot() {
			// let userPhone = "17337823986"

			selectBussinessParkinglot(this.userPhone).then(res => {
				// selectBussinessParkinglot(userPhone).then(res =>{
				if (res.code == 200) {
					let checkedParkOptions = res.data;
					if (checkedParkOptions.length > 0) {
						checkedParkOptions.map(item => {
							item.label = item.parkName;
						});
						console.log(checkedParkOptions, 'checkedParkOptions');
						this.checkedPark = checkedParkOptions[0].parkName;
						this.checkedParkId = checkedParkOptions[0].id;
						this.setCheckedParkingLotId(checkedParkOptions[0].id);
						this.getBussinessCoupon()
					}
					this.checkedParkOptions = checkedParkOptions;
				}
			})
		},
		/** 获取商户可用停车券列表*/
		getBussinessCoupon() {
			console.log("触发");
			let expirationTime = this.formatDate(new Date());
			selectBussinessCoupon({ businessPhone: this.userPhone, expirationTime, parkinglotId: this.checkedParkId }).then(res => {
				//  selectBussinessCoupon({businessPhone:"17337823986", expirationTime, parkinglotId:this.checkedParkId}).then(res =>{
				this.couponList = res.data;
				this.$refs.scroll.refresh()
			})
		},
		/** 购买停车券按钮操作*/
		handleBuy() {
			this.$router.push('parkingFeeList')
		},
		/** 立即发放按钮操作*/
		handleRation(id) {
			this.setTaskId(id);
			this.$router.push({ name: 'rationFee' });
		},
		/** 预付券立即发放按钮操作*/
		handlePayment(item) {




			this.setTaskId(item.id);
			this.$router.push({ name: 'PaymentCertificate', query: { couponTaskId: item.id, parkinglotId: item.parkinglotId } });
		},
		/**按天发放*/
		handleRationByDay(id) {
			this.isShowQrcode = true;
			this.createUrl(id)
		},
		createUrl(id) {
			this.url = scan.link + "?taskId=" +
				encrypt.encrypt(id) + "&timeStamp=" + (new Date()).valueOf() + '&isChecked=' + false + "&isGZH=" + true;
		},
		/** 代付按钮操作*/
		PaymentType(id, parkinglotId, couponType) {


			this.setTaskId(id);

			this.$router.push({ name: 'Payment', query: { couponTaskId: id, parkinglotId: parkinglotId, couponType: couponType } });
		},
		/** 直接绑定按钮操作*/
		handleBind(id, parkinglotId, couponType) {
			console.log(id, parkinglotId, couponType);
			
			this.setTaskId(id);
			this.$router.push({ name: 'directBind', params: { parkinglotId, couponType } });
		},
		/** 选择发放方式按钮操作*/
		chooseRationType(id) {
			this.$weui.picker(this.checkedRationOptions, {
				onConfirm: result => {
					this.rationType = result[0].id;
					//按天发放
					if (result[0].id === 1) {
						this.handleRationByDay(id)
					} else if (result[0].id === 2) {
						this.getCouponIdList(id)
					} else if (result[0].id === 3) {
						this.getUserInputPlateQrcode(id)
					} else if (result[0].id === 4) {
						this.getTransmissionCouponIdList(id)
					} else {
						this.CreateQrcode(id)
					}
				},
				title: '发放方式'
			});
		},
		makeUrl(id, i) {
			this.url = scan.link + "?couponId=" + encrypt.encrypt(this.couponUrlList[i]) + "&taskId=" + encrypt.encrypt(id) + "&isGZH=" + true + '&isChecked=' + false;

		},
		TransmissionmakeUrl(id, i) {
			this.url = scan.TransmissionLink + "?couponId=" + encrypt.encrypt(this.couponUrlList[i]) + "&taskId=" + encrypt.encrypt(id) + "&isGZH=" + true + '&isChecked=' + false + '&bindMethod=1'+'&parkinglotId='+encrypt.encrypt(this.checkedParkId);

		},
		/**用户直接绑定车牌二维码操作*/
		getUserInputPlateQrcode(id) {
			this.isShowQrcode = true;
			this.url = 'http://parkinglot.scan.easthuaxin.com/weChat/userNoFollowToGetCoupon' + "?taskId=" + encrypt.encrypt(id) +
				"&parkinglotId=" + encrypt.encrypt(this.checkedParkId) + "&isUserBindPlate=" + true;
		},
		CreateQrcode(id) {
			this.isShowQrcode = true;
			const today = new Date();
			// 获取当前时间(today)的年份
			const year = today.getFullYear();
			// 获取月份
			const month = String(today.getMonth() + 1).padStart(2, '0');
			// 获取当前日
			const day = String(today.getDate()).padStart(2, '0');
			let time = `${year}-${month}-${day}`
			let qrcodeUrl = "http://parkinglot.scan.easthuaxin.com/weChat/paymentAdvance" + "?taskId=" + id + "&prepay=" + false + "&parkinglotId=" + this.checkedParkId + "&time=" + time;
			// let Url = "http://192.168.101.194:8081/weChat/paymentAdvance" +"?taskId=" +this.periodRow.id+"&prepay="+false +"&parkinglotId=" +this.periodRow.parkinglotId +"&time=" +time;
			let password = 'hx1234!@#$'
			let key = this.generateSignature(qrcodeUrl, password)
			this.url = qrcodeUrl + "&key=" + encodeURIComponent(key);

		},
		generateSignature(data, secretKey) {
			return CryptoJS.HmacSHA256(data, secretKey).toString(CryptoJS.enc.Base64);
		},
		getTransmissionCouponIdList(id) {
			this.stopCouponRotation(); // 先停止之前的轮询

			sendCoupon({ taskId: id }).then(res => {
				this.couponUrlList = res.data;

				if (this.couponUrlList && this.couponUrlList.length > 0) {
					this.isShowQrcode = true;
					let i = 0;

					this.TransmissionmakeUrl(id, i);

					this.timer = setInterval(() => {
						i++;
						if (i >= this.couponUrlList.length) {
							i = 0;
						}
						this.TransmissionmakeUrl(id, i);
					}, 5000);

					// 每30秒刷新一次券列表，确保显示的都是可用券
					this.refreshTimer = setInterval(() => {
						this.refreshCouponList(id);
					}, 30000);

				} else {
					this.$weui.alert('暂无券');
					this.isShowQrcode = false;
				}
			}).catch(error => {
				console.error('获取券列表失败:', error);
				this.$weui.alert('获取券信息失败');
				this.isShowQrcode = false;
			});
		},

		// 刷新券列表的方法
		refreshCouponList(id) {
			sendCoupon({ taskId: id }).then(res => {
				const newCouponList = res.data;

				// 如果券列表发生变化
				if (newCouponList.length !== this.couponUrlList.length) {
					this.couponUrlList = newCouponList;

					// 如果没有可用券了，停止轮询
					if (this.couponUrlList.length === 0) {
						this.stopCouponRotation();
						this.$weui.alert('所有券已被领取完毕');
						this.isShowQrcode = false;
					}
				}
			}).catch(error => {
				console.error('刷新券列表失败:', error);
			});
		},

		// 更新停止轮询的方法
		stopCouponRotation() {
			if (this.timer) {
				clearInterval(this.timer);
				this.timer = null;
			}
			if (this.refreshTimer) {
				clearInterval(this.refreshTimer);
				this.refreshTimer = null;
			}
			this.isShowQrcode = false;
		},
		getCouponIdList(id) {
			sendCoupon({ taskId: id }).then(res => {
				this.couponUrlList = res.data;
				let i = 0;
				if (this.couponUrlList.length > 0) {
					this.isShowQrcode = true;
					this.makeUrl(id, i);
					this.timer = setInterval(() => {
						i++;
						if (i < this.couponUrlList.length) {
							this.makeUrl(id, i)
						} else {
							i = 0;
							this.makeUrl(id, i)
						}
						sendCoupon({ taskId: id }).then(res => {
							// this.couponList = res.data;
						})
					}, 5000);
				} else {
					this.$weui.alert('暂无券');
				}
			})
		},
		close() {
			if (this.rationType === 1) {
				this.isShowQrcode = false
			} else {
				this.isShowQrcode = false;
				clearInterval(this.timer)
				this.timer = null
			}
		},
		/** 发放记录按钮操作*/
		handleRecord(item) {
			this.setTaskId(item.id);
			// this.$router.push({name:'rationRecord'});
			this.$router.push({ name: "rationRecord", params: { couponName: item.couponName } });

		},
		/** 选择停车场操作*/
		handleParkOption() {
			this.$weui.picker(this.checkedParkOptions, {
				onChange: result => {
					this.checkedPark = result[0].parkName;
					this.setCheckedParkingLotId(result[0].id);
		
				},
				onConfirm: result => {
					this.checkedPark = result[0].parkName;
					this.setCheckedParkingLotId(result[0].id);
					this.checkedParkId = result[0].id;
					this.getBussinessCoupon()
				},
				title: '可选停车场'
			});
		},
	}
}
</script>

<style scoped lang="stylus">
	@import '~common/stylus/variable';
	.wrapper {
		/*padding-bottom 20px*/
		.weui-article{
			padding-bottom 0
			p {
				font-size $article-merchant-p
				color $article-p-color
				line-height 20px
			}
			.weui-cell_select-after{
				padding-left 0
			}
		}
		.weui-btn-area{
			margin-top 0
			.weui-btn_primary, .weui-btn_disabled{
				width 100%
			}
		}
		.fee-list-wrapper{
			.weui-cells-wrapper{
				/*background-color #fff*/
				/*padding 5px 0*/
				margin 5px 10px 10px 10px
				border-radius 10px
				box-shadow  0 0 5px #eee
				display flex
				border-bottom:1px solid rgba(0, 0, 0, 0.1);
				.icon-guoqi{
					font-size: 180px;
					opacity: .3;
					position: absolute;
					top: 10%;
				}
			}
			.weui-cells{
				width 75%
				margin-top 0
				border-top-left-radius 10px
				border-bottom-left-radius 10px
				padding 5px 0
				.weui-cell{
					padding-top 5px
					padding-bottom 5px
					.weui-cell__bd{
						width 35%!important
						font-size 12px
					}
					.weui-cell__ft{
						width 60%!important
						font-size 12px
						text-align left
					}
				}
				.weui-cell:before{
					border-top none!important
				}
			}
			.weui-cells:before{
				border-top: none!important
			}
			.weui-cells:after{
				border-bottom: none!important
			}
			.weui-btn-wrapper{
				width 24%
				padding 5px 0
				display flex
				flex-direction column
				justify-content space-around
				align-items center
				.weui-btn_default{
					font-size 13px
				}
				.weui-btn_mini{
					line-height 1.8
				}
			}
		}
		.cube-scroll{
			position: relative;
			text-align: left;
			white-space: normal;
			max-height: 52%
			overflow hidden
			/*background: #ffffff;*/
			margin-bottom 50px
		}
	}
	.no-enter{
		position absolute
		top 0
		left 0
		right 0
		background-color #ffffff
		height 100%
		z-index 9999
		display flex
		justify-content center
		align-items center
		font-size 20px
		p{
			padding-bottom 70px
		}
	}
</style>
